exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#content .grid.grid--cards {\n  margin-top: -1.5rem;\n  margin-bottom: -1.5rem;\n}", ""]);

// exports
